import React from 'react';
import PropTypes from 'prop-types';
import { SvgIcon } from '@material-ui/core';

const scheduleChecked = (props) => {
  const { color, ...otherProps } = props;

  return (
    <SvgIcon
      {...otherProps}
      color={color === 'primary' ? 'primary' : undefined}
      htmlColor={color === 'primary' ? undefined : 'white'}
    >
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.025 0H4.305C2.66 0 1.33 1.25078 1.33 2.79781V4.11442H0V5.06897H1.33V9.80877H0V10.7633H1.33V15.4702H0V16.4248H1.33V18.2022C1.33 19.7492 2.66 21 4.305 21H18.025C19.67 21 21 19.7492 21 18.2022V2.73197C21 1.25078 19.67 0 18.025 0ZM19.88 2.79781V18.2351C19.88 19.1897 19.04 19.9796 18.025 19.9796H7.105V1.05329H18.025C19.04 1.05329 19.88 1.84326 19.88 2.79781ZM2.485 15.5031V10.7633H3.885V9.80877H2.485V5.06897H3.885V4.11442H2.485V2.79781C2.485 1.84326 3.325 1.05329 4.34 1.05329H6.125V19.9467H4.34C3.325 19.9467 2.485 19.1897 2.485 18.2022V16.4577H3.885V15.536H2.485V15.5031Z" fill="currentColor" />
        <path d="M15.7459 9C15.631 9 15.4873 9.02762 15.4011 9.11045L11.9237 12.3686L10.7455 11.3746C10.5156 11.2089 10.2569 11.2365 10.1132 11.4298C9.9408 11.6231 9.96953 11.8992 10.1707 12.0373L11.6363 13.2798C11.6651 13.3074 11.7225 13.3626 11.8088 13.3626C11.8662 13.3903 11.9525 13.3903 11.9812 13.3903C12.1249 13.3903 12.2399 13.335 12.3261 13.2798L16.1195 9.74552C16.2057 9.66268 16.2632 9.55224 16.2632 9.44179C16.2632 9.33134 16.2057 9.2209 16.1195 9.13806C15.9758 9.05523 15.8609 9 15.7459 9Z" fill="currentColor" />
      </svg>
    </SvgIcon>
  );
};

scheduleChecked.propTypes = {
  color: PropTypes.string,
};

scheduleChecked.defaultProps = {
  color: 'primary',
};

export default scheduleChecked;
